function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { Component } from 'react';
import Chart from 'react-apexcharts';
import 'regenerator-runtime/runtime.js';
var on = true;
var defaultOptions = {
  chart: {
    background: 'white',
    type: 'line',
    stacked: false
  },
  dataLabels: {
    enabled: false
  },
  stroke: {
    width: [3, 3, 3]
  },
  title: {
    text: 'HDL Transaction Statistics',
    align: 'left',
    offsetX: 110
  },
  xaxis: {
    categories: [],
    labels: {
      hideOverlappingLabels: true,
      rotate: 0,
      style: {
        colors: 'black'
      }
    }
  },
  yaxis: [{
    axisTicks: {
      show: true
    },
    axisBorder: {
      show: true,
      color: '#008FFB'
    },
    labels: {
      style: {
        colors: '#008FFB'
      }
    },
    title: {
      text: 'Transaction Count',
      style: {
        color: '#008FFB'
      }
    },
    tooltip: {
      enabled: true
    }
  }, {
    seriesName: 'Volume',
    opposite: true,
    axisTicks: {
      show: true
    },
    axisBorder: {
      show: true,
      color: 'black'
    },
    labels: {
      style: {
        colors: 'black'
      }
    },
    title: {
      text: 'Unit Volume',
      style: {
        color: 'black'
      }
    }
  }],
  tooltip: {
    fixed: {
      enabled: true,
      position: 'topLeft',
      // topRight, topLeft, bottomRight, bottomLeft
      offsetY: 30,
      offsetX: 60
    }
  },
  legend: {
    horizontalAlign: 'left',
    offsetX: 40
  }
};
var defaultSeries = [{
  name: 'series-1',
  data: [30, 40, 45, 50, 49, 60, 70, 91]
}];

function parseDefault(data) {
  var series1 = [];
  var series2 = [];
  var i = false;
  data.data.forEach(function (point) {
    i = !i;

    if (i) {
      series1.push(parseInt(point['tx-count']));
      series2.push(parseInt(point.volume));
    }
  });
  return [{
    name: 'Transactions',
    type: 'area',
    data: series1
  }, {
    name: 'Volume',
    type: 'bar',
    color: '#3a904f',
    data: series2
  }];
}

var PipeChart = /*#__PURE__*/function (_Component) {
  _inherits(PipeChart, _Component);

  var _super = _createSuper(PipeChart);

  function PipeChart(props) {
    var _this;

    _classCallCheck(this, PipeChart);

    _this = _super.call(this, props);

    _this.toggle = function () {
      on = !on;
      var color = on ? 'red' : 'blue';

      _this.setState({
        options: _objectSpread(_objectSpread({}, _this.state.options), {}, {
          chart: _objectSpread(_objectSpread({}, _this.state.options.chart), {}, {
            background: color
          })
        })
      }, function () {
        console.log(_this.state.options);
      });
    };

    _this.update = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var data, dataObject, newSeries;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fetch(_this.state.url);

            case 2:
              data = _context.sent;
              _context.next = 5;
              return data.json();

            case 5:
              dataObject = _context.sent;
              newSeries = _this.state.parse(dataObject);

              if (newSeries.length === 2 && typeof newSeries[0][0] === 'number') {
                _this.setState({
                  series: newSeries[0]
                });

                _this.setState({
                  options: _objectSpread(_objectSpread({}, _this.state.options), {}, {
                    labels: newSeries[1]
                  })
                });
              } else {
                _this.setState({
                  series: newSeries
                });
              }

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    _this.state = {
      options: props.options || defaultOptions,
      series: props.series || defaultSeries,
      labels: props.labels || [],
      interval: props.interval || 20000,
      width: props.width || '80%',
      type: props.type || 'area',
      url: props.url || 'https://indexer.algoexplorerapi.io/stats/v2/movements?time-start=1638618727&interval=6H&asset-id=137594422',
      parse: props.parseFunction || parseDefault
    };
    return _this;
  }

  _createClass(PipeChart, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (typeof this.props.update === 'function') {
        this.props.update();
      } else {
        this.update();
      }

      setInterval(this.props.update || this.update, this.state.interval); //setInterval(this.toggle, 100)
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "pipeChart",
        align: "center"
      }, /*#__PURE__*/React.createElement(Chart, {
        width: this.state.width,
        options: this.state.options,
        yaxis: this.state.yaxis,
        series: this.state.series,
        type: this.state.type,
        labels: this.state.labels
      }));
    }
  }]);

  return PipeChart;
}(Component);

export default PipeChart;